import {
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { useState, useEffect } from "react";
import AddPermissionToRol from "./AddPermissionToRol";
import { createRole, getRoles, updateRole } from "../../services/rolServices";
import { toast } from "react-toastify";

export default function RoleManagement() {
  const [open, setOpen] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roles, setRoles] = useState([]);
  const [newlyCreatedRoleId, setNewlyCreatedRoleId] = useState(null);
  const [editingRole, setEditingRole] = useState(null);

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setRoleName("");
    setEditingRole(null);
    setOpen(false);
  };

  const fetchRoles = async () => {
    try {
      const response = await getRoles();
      setRoles(response.data);
    } catch (error) {
      toast.error("No se pudieron cargar los roles");
    }
  };

  const handleSaveRole = async () => {
    if (!roleName.trim()) {
      toast.error("El nombre del rol no puede estar vacío");
      return;
    }

    try {
      if (editingRole) {
        // Editando rol existente
        await updateRole(editingRole.id, { name: roleName.trim() });
        toast.success("Rol actualizado exitosamente");
      } else {
        // Creando rol nuevo
        const response = await createRole({ name: roleName.trim() });
        toast.success("Rol creado exitosamente");
        setNewlyCreatedRoleId(response.data.id);
      }

      handleClose();
      await fetchRoles();
    } catch (error) {
      toast.error("Error al guardar el rol");
    }
  };

  const handleEditRole = (role) => {
    setEditingRole(role);
    setRoleName(role.name);
    handleOpen();
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <Box sx={{ p: 5 }}>
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <h2>Administrar roles y permisos</h2>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={handleOpen}>
            Crear nuevo rol
          </Button>
        </Grid>
      </Grid>

      {/* Lista de roles con botón de editar */}
      <Box sx={{ mt: 3 }}>
        {roles.map((role) => (
          <Grid
            container
            key={role.id}
            alignItems="center"
            spacing={2}
            sx={{ mb: 1 }}
          >
            <Grid item xs={6}>
              {role.name}
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => handleEditRole(role)}
              >
                Editar
              </Button>
            </Grid>
          </Grid>
        ))}
      </Box>

      {/* Componente para asignar permisos */}
      <AddPermissionToRol
        roles={roles}
        refreshRoles={fetchRoles}
        defaultSelectedRoleId={newlyCreatedRoleId}
      />

      {/* Modal para crear o editar rol */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editingRole ? "Editar rol" : "Nuevo rol"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre del rol"
            fullWidth
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleSaveRole} variant="contained">
            {editingRole ? "Actualizar" : "Crear"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
